// first: make every ResizeObserver frame-safe (no "ResizeObserver loop" notices anywhere)
import "app/utils/resizeObserverFix";
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";

import * as serviceWorker from "app/../serviceWorker";
import App from "app/App";

// third party style
import "perfect-scrollbar/css/perfect-scrollbar.css";

// "ResizeObserver loop limit exceeded / completed with undelivered notifications" is a harmless
// browser notice: a size-watcher (e.g. MUI's auto-growing text box) could not finish in one frame,
// so the browser delivers the change on the next frame. Nothing is broken, but the development
// server shows it as a full-screen "Uncaught runtime errors". Swallow only this notice — listening
// in the capture phase runs before the dev overlay's handler; every other error still shows.
const RESIZE_OBSERVER_NOTICE = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener(
  "error",
  (e) => {
    if (RESIZE_OBSERVER_NOTICE.test(e?.message || "")) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);
// const express=require('express');
// var app=express();
// const apiRoutes = require("../src/api");
//  app.use("/api",apiRoutes);
const root = createRoot(document.getElementById("root"));

root.render(
  <HashRouter>
    <App />
  </HashRouter>
);

serviceWorker.unregister();
